<template>
  <div class="ll-scrollable-wrap">
    <div
      ref="scrollContainer"
      v-scroll:throttle="{fn: $_onScroll, throttle: 32 }"
      class="content"
      :class="{disabled:disabled}"
      :options="{
        suppressScrollX:isDisabledX,
        suppressScrollY:isDisabledY,
        wheelPropagation:!isDisabledY,
      }"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlScrollableWrap",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isDisabledY: {
      type: Boolean,
      default: false,
    },
    isDisabledX: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    position: {
      scrollTop: 0,
      scrollLeft: 0,
      scrollTotalHeight: 0,
      windowTotalHeight: 0,
    },
  }),
  watch: {
    position() {
      this.$emit("input", this.position);
      this.$emit("scroll-search");
    },
  },
  mounted() {
    this.position = this.value;
    this.$_updateVh();
  },
  created() {
    window.addEventListener("resize", this.$_updateVh);
  },
  destroyed() {
    window.addEventListener("resize", this.$_updateVh);
  },
  methods: {
    $_updateVh() {
      setTimeout(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      }, 100);
    },
    $_backToTop() {
      this.$_scrollTo({
        target: this.$refs.scrollContainer.$el,
        duration: 1000,
      });
    },
    $_scrollTo({ to = 0, target = null, duration = 300 }) {
      let start;
      if (!target) {
        start = document.body.scrollTop || document.documentElement.scrollTop;
      } else {
        start = target.scrollTop;
      }
      let change = to - start - 200;
      let currentTime = 0;
      let increment = 20;

      let animateScroll = function () {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        if (!target) {
          document.body.scrollTop = val;
          document.documentElement.scrollTop = val;
        } else {
          target.scrollTop = val;
        }
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      animateScroll();
    },
    $_onScroll(e, position) {
      this.position = position;
      this.position.scrollTotalHeight = e.target.scrollHeight;
      this.position.windowTotalHeight = e.target.offsetHeight;
      const el = this.$refs.scrollContainer;
      el.classList.add('show-scrollbar');

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        el.classList.remove('show-scrollbar');
      }, 1000); // 停止滾動 1 秒後隱藏 scrollbar
    },
  },
};
</script>
<style lang="scss">
.ll-scrollable-wrap {
  .content {
    position: relative;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100 - 76px);
    &.disabled {
      overflow: visible;
    }
    overflow-x: auto;
    overflow-y: scroll;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;

    /* 針對 Webkit (Chrome, Edge, Safari) 瀏覽器 */
    &::-webkit-scrollbar {
      width: 0px; /* 滾動條預留的寬度 */
      background: transparent; /* 整個滾動條區域的背景設為透明 */
    }

    /* 滾動條軌道：保持透明 */
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    /* 滾動條拇指 (滑塊)：預設透明 */
    &::-webkit-scrollbar-thumb {
      background-color: transparent; /* 預設為透明 */
      border-radius: 4px;
      /* 平滑過渡效果 */
      -webkit-transition: background-color 0.3s ease-in-out;
      transition: background-color 0.3s ease-in-out;
    }

    /* 滾動條拇指 (滑塊) 在顯示時的樣式 */
    &.show-scrollbar::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.5); /* 滾動時顯示半透明黑色 */
    }

    /* 鼠標懸停在容器上時，也讓滾動條拇指顯示 */
    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.5);
    }


    /* 針對 Firefox 瀏覽器 */
    /* 注意：Firefox 對於滾動條樣式控制不如 Webkit 精細。
    scrollbar-width 和 scrollbar-color 同時控制軌道和拇指。
    要達到完全透明軌道而只顯示拇指比較困難，只能讓兩者都非常淡。*/
    scrollbar-width: thin; /* 預設細滾動條 */
    transition: scrollbar-color 0.3s ease-in-out;

    /* 滾動時或鼠標懸停時的 Firefox 滾動條樣式 */
  }
}
@media print {
  .ll-scrollable-wrap {
    .content {
      overflow: visible;
      height: auto;
    }
  }
}
</style>